/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateManualDevelopmentStageInformationDto } from '../../models/create-manual-development-stage-information-dto';

export interface DevelopmentStageControllerCreateManualV1$Params {
      body: CreateManualDevelopmentStageInformationDto
}

export function developmentStageControllerCreateManualV1(http: HttpClient, rootUrl: string, params: DevelopmentStageControllerCreateManualV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, developmentStageControllerCreateManualV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

developmentStageControllerCreateManualV1.PATH = '/api/v1/development-stage/manual';
